import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import {envelope, facebook, google} from 'shared/icons';
import {isFirstTime, register, login, externalLogin, externalRegister, resetPassword, FACEBOOK, GOOGLE} from '../shared/helpers/loginHelper';
import _ from 'lodash';
import * as Colors from 'material-ui/styles/colors';
import FontIcon from 'material-ui/FontIcon';
import platform from 'platform';
import validator from 'validator';
import jQuery from 'jquery';
import {getAttentionAnimation} from 'shared/helpers/animationHelper';
import MobileDetect from 'mobile-detect';
import SvgIcon from 'material-ui/SvgIcon';
import RaisedButton from 'material-ui/RaisedButton';
import {TweenMax} from 'gsap'; // eslint-disable-line no-unused-vars
import GoogleLogin from 'shared/vendor/react-google-login/GoogleLogin';
// import {makeACopy} from 'shared/helpers/copyTemplateHelper'; // todo move to prop if we re-enable temp
import {withRouter} from 'react-router';
/* global Linear Bounce Back SlowMo Ease TimelineLite TweenLite */
/* eslint-disable react/no-did-update-set-state */

const TRANSITOIN_DURATION_MS = 450;
const TITLE_HEIGHT = 95;
const BUTTONS_HEIGHT = 180;
const MIN_WIDTH_FOR_FULL_ELEMENT = 325;
const RIGHT = 'right';
const LEFT = 'left';
const REGISTER = 'register';
const LOGIN = 'login';
const BUTTON_WIDTH = '40%';

const isMobile = !_.isNil(new MobileDetect(window.navigator.userAgent).mobile());

const CARDS = {
  REGISTER: 0,
  LOGIN: 1,
  RESET_PASSWORD: 2,
  CONNECT: 3,
  EMAIL_REGISTER: 4,
  EMAIL_LOGIN: 5,
};

const HASH = {
  [CARDS.EMAIL_REGISTER]: '#signup',
  [CARDS.EMAIL_LOGIN]: '#login',
  [CARDS.RESET_PASSWORD]: '#forgot_password',
};

function isTransfrom3DSupported() {
  return !(platform.name === 'IE' || platform.name === 'Safari' || (platform.product && (platform.product.toLowerCase().indexOf('iphone') !== -1)));
}

const styles = {
  root: {
    width: '100%',
    minHeight: 'inherit',
    position: 'relative',
    transformStyle: isTransfrom3DSupported() ? 'preserve-3d' : 'auto',
    overflow: isTransfrom3DSupported() ? 'visible' : 'hidden',
  },
  overflowHidden: {
    width: '100%',
    minHeight: 'inherit',
    position: 'relative',
    overflow: isTransfrom3DSupported() ? null : 'hidden',
  },
  cardContainer: {
    transition: 'all ' + TRANSITOIN_DURATION_MS + 'ms ease-in-out',
    width: '100%',
    minHeight: 'inherit',
    perspective: isTransfrom3DSupported() ? 556 : null,
    transformStyle: isTransfrom3DSupported() ? 'preserve-3d' : 'auto',
  },
  card: {
    transition: 'all ' + TRANSITOIN_DURATION_MS + 'ms ease-in-out',
    width: '100%',
    backgroundColor: 'white',
    minHeight: 'inherit',
    backfaceVisibility: 'hidden',
    position: 'absolute'
  },
  input: {
    width: '90%',
    marginLeft: '5%',
    position: 'relative',
    top: -10
  },
  button: {
    width: '90%',
    align: 'center',
    height: 50,
    lineHeight: '50px',
    marginLeft: '5%',
    marginRight: '5%',
  },
  title: {
    marginTop: 25,
    marginBottom: 5,
    textAlign: 'center'
  },
  subTitle: {
    marginTop: 0,
    marginBottom: 0,
    fontSize: 16,
  },
  bottomElement: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: 'calc(100%)',
    fontSize: 16,
    padding: 20,
    display: 'flex'
  },
  link: {
    color: '#689f38',
    cursor: 'pointer',
    ':hover': {
      color: '#ed6d23'
    },
    fontSize: 16,
    lineHeight: 1,
  },
  icon: {
    fontSize: 'inherit'
  },
  arrow: {
    fontSize: '150%',
    position: 'absolute',
    left: 20,
    top: 30,
  },
  error: {
    color: Colors.red900,
    backgroundColor: Colors.red50,
    padding: 8,
    marginLeft: '15%',
    width: '80%',
    fontSize: 16
  },
  errorIcon: {
    fontSize: 16,
    paddingRight: 5,
  },
  titleBlock: {
    minHeight: TITLE_HEIGHT,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  busyOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    cursor: 'wait',
    width: '100%',
    height: '100%',
    zIndex: 10000
  },
  terms: {
    position: 'absolute',
    top: isMobile ? '-10%' : '103%',
    fontSize: 12,
    textAlign: 'center',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  termsInner: {
    maxWidth: '100vw',
    padding: isMobile ? '0px 10px' : '0px',
    lineHeight: 'normal',
  },
  flexContainer: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: BUTTONS_HEIGHT,
  },
  emailRegisterAndEmailLoginButton: {
    width: BUTTON_WIDTH,
    height: 50,
    lineHeight: '50px',
    margin: 'auto',
    display: 'block',
  }
};

const classes = require('./LoginWidget.scss');
@withRouter
export default class LoginWidget extends Component {

  state = {
    rootWidth: null,
    currentCard: null,
    emailError: null,
    globalError: null,
    busy: false,
    passwordResetComplete: false,
    googleResponse: null,
    authType: null,
    nextCard: null,
    cardDirection: null,
    rotate: false,
    facebookResponse: {},
  };

  componentWillMount() {
    const {tempUser, ebayConnectEmail, location} = this.props;
    this.registerCard = CARDS.EMAIL_REGISTER;
    this.loginCard = CARDS.EMAIL_LOGIN;
    let hashCard;
    switch (location.hash) {
      case HASH[CARDS.EMAIL_REGISTER]:
        hashCard = CARDS.EMAIL_REGISTER;
        break;
      case HASH[CARDS.EMAIL_LOGIN]:
        hashCard = CARDS.EMAIL_LOGIN;
        break;
      case HASH[CARDS.RESET_PASSWORD]:
        hashCard = CARDS.RESET_PASSWORD;
        break;
      default:
        hashCard = null;
        break;
    }
    if (_.isNull(hashCard)) {
      if (ebayConnectEmail || (!tempUser && !isFirstTime())) {
        this.setState({
          currentCard: this.loginCard,
          email: ebayConnectEmail ? ebayConnectEmail : ''
        });
      } else {
        this.setState({
          currentCard: this.registerCard,
        });
      }
    } else {
      this.setState({
        currentCard: hashCard,
      });
    }
  }

  componentDidMount() {
    this.resize();
    const referrerPublicId = _.get(this, 'props.location.query.referrerId');
    if (referrerPublicId) {
      window.setTimeout(() => {
        window.analytics.track('Referred User Landing Page', {'Referrer Public Id': referrerPublicId});
      }, 2 * 1000);
    }
    window.addEventListener('resize', this.resize);
    jQuery('.goto-signup a').click(() => {
      if (this.state.currentCard === this.registerCard) {
        this.getAttentionAnimation();
      } else {
        this.switchToCard(this.registerCard);
      }
    });
    jQuery('.goto-login a').click(() => {
      if (this.state.currentCard === this.loginCard) {
        this.getAttentionAnimation();
      } else {
        this.switchToCard(this.loginCard);
      }
    });

  }

  componentDidUpdate(prevProps, prevState) {
    const {nextCard} = this.state;
    if (nextCard !== prevState.nextCard && !_.isNull(nextCard)) {
      window.setTimeout(() => {
        _.defer(() => {
          this.setState({
            rotate: true,
          });
          window.setTimeout(() => {
            this.setState({
              currentCard: nextCard,
              nextCard: null,
              rotate: false,
              emailError: null,
              globalError: null,
              cardDirection: null,
            });
          }, TRANSITOIN_DURATION_MS);
        });
      }, 10);
    }
  }

  getFacebookResponse = () => {
    const handleLoginStatus = (response) => {
      this.setState({
        facebookResponse: response
      });
    };
    if (window.loaded) {
      window.FB.getLoginStatus(handleLoginStatus);
    } else {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: window.facebookAppId,
          cookie: true,
          version: 'v2.2'
        });
        window.FB.getLoginStatus(handleLoginStatus);
      };
    }
  };

  getAttentionAnimation = () => {
    getAttentionAnimation('#loginWidget');
  };

  getCardStyle(card) {
    const rad = 0.2886 * this.state.rootWidth;
    const cardStyles = isTransfrom3DSupported() ? {
      front: {
        transformOrigin: '50% 50% -' + rad + 'px',
        transform: 'none'
      },
      right: {
        transformOrigin: '50% 50% -' + rad + 'px',
        transform: 'rotateY(120deg)'
      },
      left: {
        transformOrigin: '50% 50% -' + rad + 'px',
        transform: 'rotateY(-120deg)'
      }} : {
        front: {
          left: 0
        },
        right: {
          left: '100%'
        },
        left: {
          left: '-100%'
        }};

    const {cardDirection, currentCard, nextCard, rotate} = this.state;
    if (card === currentCard) {
      if (rotate) {
        return (cardDirection === RIGHT) ? cardStyles.left : cardStyles.right;
      }
      return cardStyles.front;
    }
    if (card === nextCard) {
      if (rotate) {
        return cardStyles.front;
      }
      return (cardDirection === RIGHT) ? cardStyles.right : cardStyles.left;
    }
  }

  getGoogleButton(type) {
    const func = (type === LOGIN) ? this.responseGoogleSuccessLogin : this.responseGoogleSuccessRegister;
    const label = (type === LOGIN) ? 'Login With Google' : 'Sign Up With Google';
    // const clientId = typeof window.googleAppId === 'string' ? window.googleAppId : '';
    return (
      <GoogleLogin
        tag={RaisedButton}
        // clientId={clientId}
        onSuccess={func}
        onFailure={this.responseGoogleFail}
        backgroundColor={'#D34836'}
        style={styles.button}
        label={label}
        labelPosition={'after'}
        labelColor={Colors.white}
        icon ={
          <SvgIcon width="24" height="24" viewBox="0 0 24 24">
            <path fill="#fff" d={google}/>
          </SvgIcon>
        }
      />
    );
  }

  getFacebookButton(type) {
    const func = (type === LOGIN) ? this.facebookLogin : this.facebookRegister;
    const label = (type === LOGIN) ? 'Login With Facebook' : 'Sign Up With Facebook';
    return (
      <RaisedButton
        disabled={!window.loaded}
        label={window.loaded ? label : 'invalid in private mode'}
        onClick={func}
        icon={
          <SvgIcon width="24" height="24" viewBox="0 0 24 24">
            <path fill="#fff" d={facebook}/>
          </SvgIcon>}
        backgroundColor={'#3B5999'}
        labelColor={Colors.white}
        style={styles.button}
      />);
  }

  getPassedData() {
    const {email, password} = this.state;
    const bothNotEmpty = (!_.isEmpty(email) && !_.isEmpty(password));
    const passedPassword = bothNotEmpty ? password : null;
    const passedEmail = bothNotEmpty ? email : null;
    return {'passedEmail': passedEmail, 'passedPassword': passedPassword};
  }

  doFacebookLogin = () => {
    const {passedEmail, passedPassword} = this.getPassedData();
    const {facebookResponse} = this.state;
    const accessToken = _.get(facebookResponse, 'authResponse.accessToken');
    const redirect = this.props.location.query.redirectAfterLogin;
    if (accessToken) {
      externalLogin(FACEBOOK, passedEmail, passedPassword, accessToken, redirect, (result) => {
        if (_.get(result, 'status') === 'error') {
          if (this.state.currentCard !== CARDS.CONNECT) {
            this.switchToCard(CARDS.CONNECT);
          } else {
            this.setState({globalError: result.message});
          }
        }
      });
    }
    this.setState({busy: false});
  };

  doFacebookRegister = () => {
    const {facebookResponse} = this.state;
    const accessToken = _.get(facebookResponse, 'authResponse.accessToken');
    if (accessToken) {
      externalRegister(FACEBOOK, accessToken, (result) => {
        if (_.get(result, 'status') === 'error') {
          this.setState({globalError: result.message});
        }
      });
    }
    this.setState({busy: false});
  };

  facebookLogin = () => {
    const {facebookResponse} = this.state;
    this.setState({busy: true, authType: FACEBOOK});
    switch (facebookResponse.status) {
      case 'connected':
        this.doFacebookLogin();
        break;
      default:
        window.FB.login((response) => {
          this.setState({
            facebookResponse: response,
          });
          this.doFacebookLogin();
        }, {
          scope: 'email,public_profile',
          return_scopes: true
        });
        break;
    }
  };

  login = () => {
    if (this.validate()) {
      // const {tempUser, copyTemplateProps} = this.props;
      // const redirectUrl = tempUser ? makeACopy(copyTemplateProps) : null;
      this.setState({busy: true});
      login(this.state.email, this.state.password, null, (result) => {
        this.setState({busy: false});
        if (result.status === 'error') {
          this.setState({globalError: result.message});
        }
      });
    }
  };

  facebookRegister = () => {
    this.setState({busy: true, authType: FACEBOOK});
    const {facebookResponse} = this.state;
    switch (facebookResponse.status) {
      case 'connected':
        this.doFacebookRegister();
        break;
      default:
        window.FB.login((response) => {
          this.setState({
            facebookResponse: response,
          });
          this.doFacebookRegister();
        }, {
          scope: 'email,public_profile',
          return_scopes: true
        });
        break;
    }
  };

  register = () => {
    const {tempUser, closeDialog} = this.props;
    if (this.validate()) {
      this.setState({busy: true});
      if (tempUser) {
        jQuery.ajax({
          method: 'POST',
          url: `/application/account-page/change-password`,
          data: {
            password: '',
            newPassword: this.state.password,
          },
        }).then(response => {
          if (response.success) {
            jQuery.ajax({
              method: 'POST',
              url: `/application/account-page/update-profile`,
              data: {
                email: this.state.email,
                password: this.state.password
              },
            }).then(response => {
              this.setState({busy: false});
              if (response.success) {
                if (closeDialog) {
                  closeDialog();
                }
              } else {
                this.setState({emailError: response.message || 'Unknown Error'});
              }
            }).fail(result => {this.setState({busy: false, emailError: (result.responseJSON && result.responseJSON.message) || 'Unknown Error'});});
          } else {
            this.setState({busy: false, passwordError: response.message || 'Unknown Error'});
          }
        }).fail(result => {this.setState({busy: false, passwordError: (result.responseJSON && result.responseJSON.message) || 'Unknown Error'});});
      } else {
        register(this.state.email, this.state.password, (result) => {
          this.setState({busy: false});
          if (result.status === 'error') {
            this.setState({emailError: result.message});
          }
        });
      }
    }
  };

  resetPassword = () => {
    if (this.validate(true)) {
      this.setState({busy: true});
      resetPassword(this.state.email, (result) => {
        this.setState({busy: false});
        if (result.status === 'error') {
          this.setState({emailError: result.message});
        } else {
          this.setState({passwordResetComplete: true});
        }
      });
    }
  };

  resize = _.throttle(() => {
    if (this.refs.root) {
      this.setState({
        rootWidth: this.refs.root.offsetWidth,
      });
    }
  }, 30);

  responseGoogleFail = (response) => {
    console.log(response);
  };

  responseGoogleSuccessLogin = (response) => {
    const {passedEmail, passedPassword} = this.getPassedData();
    const redirect = this.props.location.query.redirectAfterLogin;
    this.setState({busy: true, googleResponse: response, authType: GOOGLE});
    externalLogin(GOOGLE, passedEmail, passedPassword, response.tokenObj, redirect, (result) => {
      this.setState({busy: false});
      if (_.get(result, 'status') === 'error') {
        if (this.state.currentCard !== CARDS.CONNECT) {
          this.switchToCard(CARDS.CONNECT);
        } else {
          this.setState({globalError: result.message});
        }
      }
    });
  };

  responseGoogleSuccessRegister = (response) => {
    this.setState({busy: true, googleResponse: response, authType: GOOGLE});
    externalRegister(GOOGLE, response.tokenObj, (result) => {
      this.setState({busy: false});
      if (_.get(result, 'status') === 'error') {
        this.setState({globalError: result.message});
      }
    });
  };

  switchToCard = (card, comeFrom = RIGHT) => {
    const {nextCard} = this.state;
    if (!_.isNil(nextCard)) {
      return;
    }
    this.setState({
      nextCard: card,
      cardDirection: comeFrom,
      passwordResetComplete: false,
    });
    this.props.router.replace({
      ...this.props.location,
      hash: HASH[card],
    });
  };

  enterClicked = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const {authType, googleResponse} = this.state;
      switch (this.state.currentCard) {
        case CARDS.EMAIL_LOGIN:
          this.login();
          break;
        case CARDS.EMAIL_REGISTER:
          this.register();
          break;
        case CARDS.RESET_PASSWORD:
          this.resetPassword();
          break;
        case CARDS.CONNECT:
          if (authType === GOOGLE) {
            this.responseGoogleSuccessLogin(googleResponse);
          }
          if (authType === FACEBOOK) {
            this.facebookLogin();
          }
          break;
        default:
          // unreachable;
          break;
      }
    }
  };

  validate = (emailOnly = false) => {
    if (_.isEmpty(this.state.email)) {
      this.setState({emailError: 'Email can not be empty'});
    } else if (!validator.isEmail(this.state.email, {allow_utf8_local_part: false})) {
      this.setState({emailError: 'Please enter a valid email address'});
    } else if (!emailOnly) {
      if (_.isEmpty(this.state.password)) {
        this.setState({passwordError: 'Password can not be empty'});
      } else if (_.isEmpty(_.trim(this.state.password))) {
        this.setState({passwordError: 'Password can not be all white spaces'});
      } else {
        return true;
      }
    } else {
      return true;
    }
    return false;
  };

  render() {
    const {trialDuration, tempUser, ebayConnectEmail} = this.props;
    const {currentCard, authType, googleResponse, nextCard, globalError, cardDirection} = this.state;
    const authTypeName = authType ? authType.charAt(0).toUpperCase() + authType.slice(1) : null;

    const emailField = (
      <TextField
        style={styles.input}
        hintText={ebayConnectEmail ? '' : 'Email'}
        defaultValue={this.state.email}
        floatingLabelText="Email"
        type="email"
        name="email"
        id="email"
        data-cl-automation = "email"
        inputStyle={{boxShadow: 'none'}}
        ref="email"
        onChange={(event) => {
          this.setState({email: event.target.value, emailError: null});
        }}
        value={this.state.email}
        errorStyle={{float: 'left'}}
        errorText={this.state.emailError}
        onKeyDown={this.enterClicked}
      />);
    const passwordField = (
      <TextField
        style={styles.input}
        hintText="Password"
        data-cl-automation="password"
        floatingLabelText="Password"
        type="password"
        name="password"
        id="password"
        autoComplete="off"
        inputStyle={{boxShadow: 'none'}}
        ref="password"
        onChange={(event) => {
          this.setState({password: event.target.value, passwordError: null});
        }}
        value={this.state.password}
        errorStyle={{float: 'left'}}
        errorText={this.state.passwordError}
        onKeyDown={this.enterClicked}
      />
    );

    let errorMessage;
    if (globalError) {
      errorMessage = (
        <div>
          <a key={currentCard + '4'} style={styles.link} onClick={() => this.switchToCard(CARDS.LOGIN, LEFT)}>
            <i style={styles.arrow} className="material-icons">arrow_back</i></a>
          <div
            style={styles.error}
          >
            <FontIcon style={styles.errorIcon} color={Colors.red900}
                      className="material-icons">info</FontIcon>
            {globalError}
          </div>
        </div>
      );
    }

    let cardContainerStyle;
    if (isTransfrom3DSupported()) {
      cardContainerStyle = styles.cardContainer;
    } else {
      cardContainerStyle = {...styles.cardContainer, position: 'relative'};
    }

    const termsAndConditions = (
      <div style={styles.terms} className={classes.terms}>
        <div style={styles.termsInner}>
          By signing up, you agree to Crazylister's <a target="_blank"
                                                       href="https://crazylister.com/content/Terms-of-use/">Terms of
          Use</a>, <a target="_blank" href="https://crazylister.com/content/Privacy-policy/">Privacy Policy</a> and to receive e-mails.
        </div>
      </div>);

    const emailLoginBackArrow = tempUser ? this.registerCard : CARDS.EMAIL_LOGIN;
    const cards = {
      [CARDS.EMAIL_REGISTER]: <div key={CARDS.EMAIL_REGISTER}
                                   style={{...styles.card, ...this.getCardStyle(CARDS.EMAIL_REGISTER)}}>
        <div style={styles.titleBlock}>
          <h5 style={styles.title}>
            START YOUR FREE TRIAL
          </h5>
          <p style={styles.subTitle}>
            No credit card required.
          </p>
        </div>
        <form action="/dummy" method="post">
          {emailField}
          {passwordField}
          <input type="submit" value="LOGIN" style={{display: 'none'}}/>
        </form>
        <RaisedButton
          data-cl-automation = "tryItFree"
          label="GET STARTED NOW"
          onClick={this.register}
          backgroundColor={Colors.lightGreen600}
          labelColor={Colors.white}
          style={styles.emailRegisterAndEmailLoginButton}
        />
        <div style={{...styles.bottomElement, justifyContent: 'center'}}>
          <span>
            {this.state.rootWidth >= MIN_WIDTH_FOR_FULL_ELEMENT ? 'Already have an account?' : null}
            <a
              data-cl-automation = "logInHere"
              key={CARDS.EMAIL_REGISTER + '1'}
              style={styles.link}
              onClick={() => {
                this.switchToCard(this.loginCard);
              }}> Log in here <i style={styles.icon} className="material-icons">arrow_forward</i></a>
          </span>
        </div>
        {isTransfrom3DSupported() && termsAndConditions}
      </div>,
      [CARDS.REGISTER]: <div key={CARDS.REGISTER} style={{...styles.card, ...this.getCardStyle(CARDS.REGISTER)}}>
        <div style={styles.titleBlock}>
          <h5 style={styles.title}>
            {trialDuration}-Day Free Trial
          </h5>
          <p style={styles.subTitle}>
            No credit card required.
          </p>
        </div>
        <div style = {styles.flexContainer}>
          {this.getFacebookButton(REGISTER)}
          {this.getGoogleButton(REGISTER)}
          <RaisedButton
            label={'sign up with email'}
            onClick={() => this.switchToCard(CARDS.EMAIL_REGISTER)}
            icon={
              <SvgIcon width="24" height="24" viewBox="0 0 24 24">
                <path fill="#fff" d={envelope}/>
              </SvgIcon>}
            backgroundColor={Colors.lightGreen600}
            labelColor={Colors.white}
            style={styles.button}
          />
        </div>
        <div style={{...styles.bottomElement, justifyContent: 'center'}}>
                        <span>
                          {this.state.rootWidth >= MIN_WIDTH_FOR_FULL_ELEMENT ? 'Already have an account?' : null}
                          <a key={CARDS.REGISTER + '1'} style={styles.link} onClick={() => {
                            this.switchToCard(CARDS.LOGIN);
                          }}> Log in here <i style={styles.icon} className="material-icons">arrow_forward</i></a>
                        </span>
        </div>
        {isTransfrom3DSupported() && termsAndConditions}
      </div>,
      [CARDS.LOGIN]: <div key={CARDS.LOGIN} style={{...styles.card, ...this.getCardStyle(CARDS.LOGIN)}}>
        <div style={styles.titleBlock}>
          {
            [
              <h5 key={0} style={styles.title}>
                Log in to your account
              </h5>,
              <p key={1} style={styles.subTitle}>
                Welcome back!
              </p>
            ]
          }
        </div>
        <div style={styles.flexContainer}>
          {this.getFacebookButton(LOGIN)}
          {this.getGoogleButton(LOGIN)}
          <RaisedButton
            label={'Login With Email'}
            onClick={() => this.switchToCard(CARDS.EMAIL_LOGIN)}
            icon={
              <SvgIcon width="24" height="24" viewBox="0 0 24 24">
                <path fill="#fff" d={envelope}/>
              </SvgIcon>}
            backgroundColor={Colors.lightGreen600}
            labelColor={Colors.white}
            style={styles.button}
          />
        </div>
        <div style={{...styles.bottomElement, justifyContent: 'space-between'}}>
          <a key={CARDS.LOGIN + '1'} style={styles.link} onClick={() => {
            this.switchToCard(CARDS.EMAIL_REGISTER, LEFT);
          }}>Create an account</a>
          <a key={CARDS.LOGIN + '2'} style={styles.link} onClick={() => {
            this.switchToCard(CARDS.RESET_PASSWORD);
          }}>Forgot Password?</a>
        </div>
      </div>,
      [CARDS.CONNECT]: <div key={CARDS.CONNECT} style={{...styles.card, ...this.getCardStyle(CARDS.CONNECT)}}>
        <div style={styles.titleBlock}>
          {
            errorMessage ?
              errorMessage
              :
              (
                <p style={{...styles.subTitle, marginLeft: 20, marginTop: 20, marginRight: 20, lineHeight: 1.5}}>
                  <span key={CARDS.CONNECT + '1'} style={{...styles.link}} onClick={() => {
                    this.switchToCard(CARDS.LOGIN, LEFT);
                  }}><i style={{...styles.arrow, top: 0, left: 0, position: 'relative', verticalAlign: 'bottom', marginRight: 10}} className="material-icons">arrow_back</i></span>
                  Your {authTypeName} email is different than the one used in CrazyLister. Login to CrazyLister to link the
                  accounts.
                </p>
              )
          }
        </div>
        <form action="/dummy" method="post">
          {emailField}
          {passwordField}
          <input type="submit" value="LOGIN" style={{display: 'none'}}/>
        </form>
        <div>
          <a
            style={styles.button}
            className="w-btn style_raised  color_secondary icon_none"
            onClick={ () => authType === FACEBOOK ? this.facebookLogin() : this.responseGoogleSuccessLogin(googleResponse)}
          >
            <span className="w-btn-label">Login To CrazyLister</span>
            <span className="ripple-container">
                          </span>
          </a>
        </div>
        <div style={{...styles.bottomElement, justifyContent: 'center'}}>
          <a key={CARDS.CONNECT + '2'} style={styles.link} onClick={() =>
            authType === FACEBOOK ? this.facebookRegister() : this.responseGoogleSuccessRegister(googleResponse)
          }> Create new account with {authTypeName} </a>
        </div>
      </div>,
      [CARDS.EMAIL_LOGIN]: <div key={CARDS.EMAIL_LOGIN} style={{...styles.card, ...this.getCardStyle(CARDS.EMAIL_LOGIN)}}>
        <div style={styles.titleBlock}>
          {
            errorMessage ?
              errorMessage
              :
              [
                <h5 key={2} style={styles.title}>
                    {/* <a key={CARDS.EMAIL_LOGIN + '3'} style={styles.link} onClick={() => { */}
                      {/* this.switchToCard(emailLoginBackArrow, LEFT); */}
                    {/* }}> <i style={styles.arrow} className="material-icons">arrow_back</i></a> */}
                  Log in to your account
                </h5>,
                <p key={3} style={styles.subTitle}>
                  Welcome back!
                </p>
              ]
          }
        </div>
        <form action="/dummy" method="post">
          {emailField}
          {passwordField}
          <input type="submit" value="LOGIN" style={{display: 'none'}}/>
        </form>
        <RaisedButton
          data-cl-automation = "login"
          label="LOGIN"
          onClick={this.login}
          backgroundColor={Colors.lightGreen600}
          labelColor={Colors.white}
          style={styles.emailRegisterAndEmailLoginButton}
        />
        <div style={{...styles.bottomElement, justifyContent: 'space-between'}}>
          <a key={CARDS.EMAIL_LOGIN + '1'} style={styles.link} onClick={() => {
            this.switchToCard(this.registerCard, LEFT);
          }}>Create an account</a>
          <a key={CARDS.EMAIL_LOGIN + '2'} style={styles.link} onClick={() => {
            this.switchToCard(CARDS.RESET_PASSWORD);
          }}>Forgot Password?</a>
        </div>
      </div>,
      [CARDS.RESET_PASSWORD]: <div key={CARDS.RESET_PASSWORD}
                                   style={{...styles.card, ...this.getCardStyle(CARDS.RESET_PASSWORD)}}>
        <div style={styles.titleBlock}>
          <h5 style={styles.title}>
            Password Reset
          </h5>
          {
            this.state.passwordResetComplete ?
              <div style={{paddingRight: '10%', paddingLeft: '10%'}}>
                <p style={{...styles.subTitle, textAlign: 'left'}}>
                  <i style={styles.icon} className="material-icons">done</i> Success!<br/>
                  We have sent <b>{this.state.email}</b> an email with reset instructions.
                </p>
                <p>
                  If the email does not arrive soon, check your spam folder. It was sent from contact@crazylister.com
                </p>
              </div>
              :
              <div>
                <p style={{...styles.subTitle, marginLeft: 20, marginRight: 20}}>
                  We'll email you instructions on how to reset your password.
                </p>
                {emailField}
                <RaisedButton
                  label="RESET PASSWORD"
                  onClick={this.resetPassword}
                  backgroundColor={Colors.lightGreen600}
                  labelColor={Colors.white}
                  style={styles.button}
                />
              </div>
          }
          <div style={{...styles.bottomElement, justifyContent: 'flex-start'}}>
            <a key={CARDS.RESET_PASSWORD + '1'} style={styles.link} onClick={() => {
              this.switchToCard(this.loginCard, LEFT);
            }}><i style={styles.icon} className="material-icons">arrow_back</i> Return to Login</a>
          </div>
        </div>
      </div>
    };

    const currentCardElement = _.get(cards, `${currentCard}`);
    const nextCardElement = _.get(cards, `${nextCard}`);
    const showingCards = [nextCardElement, currentCardElement];

    return (
      <div id="loginWidget" style={styles.root} ref="root">
        {!isTransfrom3DSupported() && termsAndConditions}
        <div style={styles.overflowHidden}>
          <div
            style={cardContainerStyle} className={classes.loginWidget}
          >
            {
              this.state.rootWidth &&
              showingCards
            }
          </div>
          {this.state.busy &&
          <div style={styles.busyOverlay}>
          </div>
          }
        </div>
      </div>
    );
  }
}
